import { useShowHide, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { modals } from '@modals';
import { useNavigation } from '@navigation';

interface ExitModalOutput {
	resources: ExitModalResources;
	onHandleRequestContact: () => void;
	onHandleContinue: () => void;
	onHandleLeave: () => void;
}

interface ExitModalResources {
	title: string;
	requestContact: string;
	continue: string;
	leave: string;
}

export const useExitModule = (): ExitModalOutput => {
	const t = useTranslation();
	const { navigate, exit } = useNavigation();
	const { hide } = useShowHide(modals.exitModule);

	const resources: ExitModalResources = {
		title: t('modals.exitModule.title'),
		requestContact: t('modals.exitModule.requestContact'),
		continue: t('modals.exitModule.continue'),
		leave: t('modals.exitModule.exit'),
	};

	const onHandleRequestContact = () => navigate('requestContact');
	const onHandleContinue = () => hide();
	const onHandleLeave = () => exit();

	return { resources, onHandleRequestContact, onHandleContinue, onHandleLeave };
};
